import React, { useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'
import { Spin, Modal, Form } from 'antd'
import styled from 'styled-components'
import { isAILoadingState, isLoadingState, loadingProgressState } from '../recoil/states/default'
import ButtonUC from './buttonUC'
import { QuestionOutlined } from '@ant-design/icons';
import imagePopup from '../assets/images/popup-tutorial/image-popup.png'
import CheckBoxUC from './Form/CheckBoxUC'
import pdfTutorial from '../assets/files/tutorial.pdf'
import { useLocation } from 'react-router-dom'

const ContainerDiv = styled.div`
    width: 100%;
`
const Container = ({ children }) => {
    const _isLoading = useRecoilValue(isLoadingState)
    const _isLoadingAI = useRecoilValue(isAILoadingState)
    const loadingProgress = useRecoilValue(loadingProgressState)
    const _tip = `Loading...${loadingProgress ?? ''}`
    const [openPopup, setOpenPopup] = useState(false)
    const [form] = Form.useForm();
    const isMobile = window.innerWidth <= 992
    const location = useLocation();
    const isApplicant = location?.pathname?.toLowerCase().includes('applicantprofile')

    useEffect(() => {
        const isNotShow = localStorage.getItem('is-not-show-pop-up-tutorial')
        if (isNotShow) {
            setOpenPopup(false)
        } else {
            setTimeout(() => { setOpenPopup(true) }, 1500)
        }
    }, [])

    const handleChangePopupTutorial = (e) => {
        const checked = e.target.checked ?? false
        if (checked) {
            localStorage.setItem('is-not-show-pop-up-tutorial', checked)
        } else {
            localStorage.removeItem('is-not-show-pop-up-tutorial')
        }
        // form.setFieldValue('isNotShowAgain', checked === true);
    }

    const PopupTutorial = () => {
        return (
            <Modal
                centered
                footer={false}
                open={openPopup}
                onOk={() => { }}
                onCancel={() => setOpenPopup(false)}
                width={'80%'}
                className='modal-login'
            >
                <div className="div-image w-full h-full mb-3">
                    <img className='margin-auto'
                        src={imagePopup}
                        alt={'วิธีการสมัครงาน'} />
                </div>
                <Form
                    onFinish={() => { }}
                    onFinishFailed={() => { }}
                    autoComplete="new-password"
                    form={form}
                    className="relative form-popup-turorial"
                    layout="vertical"
                >
                    <div className='flex justify-between'>
                        <CheckBoxUC
                            isShowHead={false}
                            label={'ไม่แสดงข้อความนี้อีก'}
                            onChange={handleChangePopupTutorial}
                            name={'isNotShowAgain'} />

                        <a
                            className='underline detail-tutorial'
                            href={pdfTutorial}
                            target='_blank'
                            rel='noopener noreferrer' style={{ color: '#004FD8' }}>
                            รายละเอียดวิธีการสมัครงานเพิ่มเติม
                        </a>
                    </div>
                </Form>
            </Modal>
        )
    }

    const handleOpenPopup = () => {
        const isNotShow = localStorage.getItem('is-not-show-pop-up-tutorial')
        if (isNotShow) {
            form.setFieldValue('isNotShowAgain', true);
        }
        setOpenPopup(true)
    }

    const styled = {
        floating: {
            position: 'fixed',
            bottom: isMobile ? '0.8rem' : '3rem',
            right: isMobile ? '0.8rem' : '3rem',
            zIndex: '3'
        },
        btnInFloat: {
            borderRadius: '45px',
            height: '40px',
            width: isMobile && isApplicant ? '40px' : 'auto'
        }
    }

    return (
        <Spin className={_isLoadingAI ? 'ai-loading' : ''} tip={_isLoadingAI ? 'AI Generating...' : _tip} spinning={_isLoading || _isLoadingAI}>
            <ContainerDiv>
                <div className="btn-floating"
                    style={styled.floating}>
                    <ButtonUC
                        style={styled.btnInFloat}
                        icon={<QuestionOutlined />}
                        onClick={() => handleOpenPopup()}
                    >{isMobile && isApplicant ? '' : `วิธีการสมัครงาน`}
                    </ButtonUC>
                </div>
                <div className="container-recruit">
                    {children}
                </div>
                {openPopup && <PopupTutorial />}
            </ContainerDiv>
        </Spin>
    )
}
export default Container
